var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarningRedOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22356 13.5394L7.90504 1.84679C8.05073 1.58972 8.262 1.3759 8.5173 1.22714C8.7726 1.07838 9.06279 1 9.35827 1C9.65375 1 9.94394 1.07838 10.1992 1.22714C10.4545 1.3759 10.6658 1.58972 10.8115 1.84679L17.493 13.5394C17.6402 13.7944 17.7174 14.0838 17.7168 14.3783C17.7161 14.6728 17.6376 14.9619 17.4893 15.2163C17.3409 15.4707 17.1279 15.6813 16.8718 15.8268C16.6158 15.9723 16.3259 16.0476 16.0314 16.0449H2.66843C2.37537 16.0446 2.08754 15.9672 1.83385 15.8205C1.58016 15.6738 1.36954 15.4629 1.22313 15.209C1.07673 14.9551 0.9997 14.6672 0.999775 14.3741C0.99985 14.0811 1.07703 13.7932 1.22356 13.5394Z",
    stroke: "#FF0606",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35059 6.02246V9.3632",
    stroke: "#FF0606",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35059 12.7043H9.34223",
    stroke: "#FF0606",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningRedOutline);
export default __webpack_public_path__ + "static/media/icon-warning-red-outline.d4b7d5386e26c32ac2361f774cb19ea6.svg";
export { ForwardRef as ReactComponent };